import { hasForbiddenNameCharacters, MAX_NODE_NAME_LENGTH } from 'shared';
import { z } from 'zod';

import { getTranslation } from '../../../utils/get-translation.util';

const RELATIVE_PATH_NAMES = new Set(['.', '..']);

// The naming rules of a folder and a file. Mirrors the backend `nodeNameSchema` and
// `fileNameSchema`, which stay the source of truth.
const requiredName = z
  .string()
  .trim()
  .min(1, { message: getTranslation('SPACE_NAME_REQUIRED') });

const withNameRules = (schema: z.ZodString) =>
  schema
    .refine((name) => !hasForbiddenNameCharacters(name), {
      message: getTranslation('SPACE_NAME_FORBIDDEN_CHARACTERS'),
    })
    .refine((name) => !RELATIVE_PATH_NAMES.has(name), {
      message: getTranslation('SPACE_NAME_RELATIVE_PATH'),
    });

export const spaceNodeNameSchema = withNameRules(
  requiredName.max(MAX_NODE_NAME_LENGTH, {
    message: getTranslation('CHARACTER_LIMIT_IS_COUNT', { count: MAX_NODE_NAME_LENGTH }),
  }),
);

// A file keeps the name it was uploaded with, however long.
export const spaceFileNameSchema = withNameRules(requiredName);

export const createFolderSchema = z.object({ name: spaceNodeNameSchema }).strict();

export type CreateFolderForm = z.infer<typeof createFolderSchema>;
